import { render } from "./RecentActivities.vue?vue&type=template&id=db1b742e&scoped=true"
import script from "./RecentActivities.vue?vue&type=script&lang=js"
export * from "./RecentActivities.vue?vue&type=script&lang=js"

import "./RecentActivities.vue?vue&type=style&index=0&id=db1b742e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db1b742e"]])

export default __exports__